import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryHub from './components/CategoryHub';
import BrandGrid from './components/BrandGrid';
import ArticleSection from './components/ArticleSection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const SITE_URL = typeof import.meta !== 'undefined' && (import.meta as unknown as Record<string, string>).env?.VITE_SITE_URL
  ? (import.meta as unknown as Record<string, Record<string, string>>).env.VITE_SITE_URL
  : 'https://kakobuyspreadsheet.work';

const jsonLdWebSite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': 'Kakobuy Spreadsheet Polska',
  'url': SITE_URL,
  'description': 'Kompletny przewodnik po arkuszach produktowych Kakobuy dla polskich użytkowników.',
  'inLanguage': 'pl-PL',
  'publisher': {
    '@type': 'Organization',
    'name': 'Kakobuy Spreadsheet Polska',
  },
};

const jsonLdOrganization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  'name': 'Kakobuy Spreadsheet Polska',
  'url': SITE_URL,
  'description': 'Niezależny przewodnik i społeczność użytkowników Kakobuy w Polsce. Dostarczamy sprawdzone linki, arkusze produktowe i poradniki zakupowe dla polskich użytkowników platformy.',
  'foundingDate': '2025',
  'areaServed': {
    '@type': 'Country',
    'name': 'Polska',
  },
};

const jsonLdFAQ = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  'mainEntity': [
    {
      '@type': 'Question',
      'name': 'Czym jest Kakobuy Spreadsheet?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Kakobuy Spreadsheet to arkusz kalkulacyjny zawierający linki do produktów dostępnych na platformie Kakobuy. Umożliwia szybkie przeglądanie i znajdowanie produktów w różnych kategorii takich jak Shoes, Hoodies, T-Shirts i wiele więcej.',
      },
    },
    {
      '@type': 'Question',
      'name': 'Czy Kakobuy jest bezpieczny?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Kakobuy jest platformą pośredniczącą, która działa jako agent zakupowy. Korzystanie z platformy jest bezpieczne pod warunkiem przestrzegania podstawowych zasad bezpieczeństwa i korzystania ze sprawdzonych linków produktowych.',
      },
    },
    {
      '@type': 'Question',
      'name': 'Jak korzystać z arkusza Kakobuy?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Arkusz Kakobuy zawiera kategorie produktów z bezpośrednimi linkami. Wystarczy wybrać interesującą kategorię, kliknąć link do produktu i przejść do platformy Kakobuy, aby dokonać zakupu.',
      },
    },
    {
      '@type': 'Question',
      'name': 'Jakie kategorie produktów są dostępne?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Dostępne kategorie to: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes i wiele innych.',
      },
    },
  ],
};

export default function Home() {
  return (
    <main>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdWebSite) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdOrganization) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdFAQ) }} />
      <Navbar />
      <HeroSection />
      <CategoryHub />
      <BrandGrid />
      <ArticleSection />
      <AboutSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </main>
  );
}